import { useFormContext } from "react-hook-form";

import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";

interface IVariableTypeFreeTextProps extends GeneralVariableType {}
function VariableTypeFreeText({ filter }: IVariableTypeFreeTextProps) {
	const { findFieldIndexByGuidDynamicReportVariable, idScreen } = useDynamicFiltersExport();
	const { control } = useFormContext();

	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

	return (
		<>
			<KogInputTextControlledNew
				id={idScreen("txt-freeText")}
				name={`filtersDinamics.${indexField}.value`}
				label={filter.responseServer.filterName}
				required={filter.responseServer.mandatory}
				control={control}
			/>
		</>
	);
}

export default VariableTypeFreeText;
